const target = 'stat'
export default {
  allStatStoreRankTeam: {
    config: {
      url: `/${target}/allStatStoreRankTeam`,
      method: 'post'
    }
  },
  findStatStoreRankTeam: {
    config: {
      url: `/${target}/findStatStoreRankTeam`,
      method: 'post'
    }
  },
  listStatStoreRankTeam: {
    config: {
      url: `/${target}/listStatStoreRankTeam`,
      method: 'post'
    }
  }
}
